// extracted by mini-css-extract-plugin
export default {"settingsManagementHeader":"SettingsManagement_settingsManagementHeader__KPsml","formContainer":"SettingsManagement_formContainer__b0sN9","label":"SettingsManagement_label__kqbCk"};